const Settings = {
    locale: 'en-US',
    currency: 'USD'
};
export default Object.freeze(Settings)